import { AxiosResponse } from "axios";
import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";
import { http } from "./services/https.service";
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "fr",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "fr",
  //minimum messages to avoid warning before i18n json is loaded from magnolia
});

export function loadJSONLabels(
  locale: string,
  i18nFilename: string
): Promise<AxiosResponse<LocaleMessages>> {
  //Get the right set of labels
  return http.get<LocaleMessages>(
    "/.resources/abaca-module/webresources/mgnl-i18n/" + i18nFilename + ".json"
  );
}
